// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2RJtQ","requiredAsterisk":"Info_requiredAsterisk__1cKS3"};